import React from "react";
import { Badge } from "react-bootstrap";
import { alertLevelCssClasses } from "../../../helpers/alertLevelCssClasses";

export function LevelColumnFormatter(cellContent, row) {
  return (
    <Badge variant={`${alertLevelCssClasses(row.level)}`}>{row.level}</Badge>
  );
}
